import { Box, Tab } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import LoginRedirect from '../../../components/loginredirect/LoginRedirect';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AutoPlanner from '../../../../features/autoplanner/pages/trips/bookings/AutoPlanner';
import { useAppSelector } from '../../../../app/redux/hooks';
import LogisticsDispatch from '../../../../features/truckmanagement/pages/trips/LogisticsDispatch';
import './DeliveryTripsManagement.scss';
import Trips from '../../../../features/deliverytracking/pages/trips/Trips';
import CustomExcelLoader from '../../../components/customExcelLoader/CustomExcelLoader';
import MyTrips from '../../../../features/yaantrac/pages/trips/MyTrips';
import DeliveryTrips from '../../../../features/deliverytracking/pages/trips/DeliveryTrips';

interface TabLabel {
  label: string;
  path: string;
  component: JSX.Element;
}

// Function for the management component:
function DeliveryTripsManagement() {
  const { data } = useAppSelector(state => state.auth);
  let roletype = data?.role;
  const user =
    roletype === 'ROLE_DT_ADMIN,ROLE_YAANTRAC_USER' || roletype === 'ROLE_YAANTRAC_ADMIN';
  const autoPlanner = roletype === 'ROLE_OPERATOR_ADMIN';
  const logistics = roletype === 'ROLE_LOGISTICS_ADMIN';
  const autoplannerAgent = roletype === 'ROLE_AGENT';
  const deliveryTracking = roletype === 'ROLE_DT_ADMIN';

  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState<string>('0');
  const tabLabels: TabLabel[] = [
    ...(autoPlanner || autoplannerAgent
      ? [
          {
            label: 'Auto Planner Trips',
            path: 'autoplannertrips',
            component: <AutoPlanner />
          }
        ]
      : []),
    ...(logistics
      ? [
          {
            label: 'Logistics Dispatch',
            path: 'logistics',
            component: <LogisticsDispatch />
          }
        ]
      : []),
    ...(user ? [{ label: 'My Trips', path: 'mytrips', component: <MyTrips /> }] : []),
    ...(deliveryTracking
      ? [
          {
            label: 'Dispatch',
            path: 'deliverytrips',
            component: <DeliveryTrips />
          }
        ]
      : [])
  ];

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    const defaultPath =
      autoPlanner || autoplannerAgent
        ? 'autoplannertrips/tours'
        : logistics
        ? 'logistics'
        : deliveryTracking
        ? 'deliverytripsmanagment'
        : 'mytrips';
    const pathUrl = tabLabels.findIndex(tab => location.pathname.includes(tab.path));
    if (location.pathname === '/trips') {
      navigate(`${defaultPath}`);
    } else {
      setValue(pathUrl.toString());
    }
  }, [location.pathname, navigate, tabLabels]);

  return (
    <>
      {!autoPlanner && !autoplannerAgent ? (
        <Box className='trips-management-container'>
          <TabContext value={value}>
            <Box className='tab-context animate__animated animate__slideInRight animate__fast'>
              <Box className='tab-list'>
                {/* Loop function for the tab names: */}
                <TabList
                  onChange={handleChange}
                  aria-label='lab API tabs example'
                  variant='scrollable'
                  allowScrollButtonsMobile
                >
                  {tabLabels.map((tab, index) => (
                    <Tab
                      key={index}
                      className='tab'
                      label={tab.label}
                      value={index.toString()}
                      component={Link}
                      to={`${tab.path}`}
                    />
                  ))}
                </TabList>
              </Box>
            </Box>

            <Box sx={{ height: `calc(100vh - 100px)` }}>
              {/* Loop function for the tab name components: */}
              {tabLabels.map((tab, index) => (
                <TabPanel key={index} value={index.toString()} className='tab-panel'>
                  {tab.component}
                </TabPanel>
              ))}
            </Box>

            <LoginRedirect />
          </TabContext>
        </Box>
      ) : (
        <AutoPlanner />
      )}
    </>
  );
}

export default DeliveryTripsManagement;
